
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { addPointageByUserId, getMonthPointageByUserId } from "./../Services/Pointeuse/PointageApi";
import { getUsersByCode } from "./../Services/Pointeuse/UsersApi";
import { getDistanceBetweenTwoCoordinates } from "./../Utils/DistanceUtils";
import { filterPointageByWord } from "./../Utils/SortObject";
import ErrorCustum from "./Others/ErrorCustum";
import Pagination from "./Others/Pagination";
import ImageComponent from "./Styles/ImageComponent";
import { getAllSettings } from "./../Services/Pointeuse/SettingsApi";
import { getEntrepriseByCode } from "./../Services/Pointeuse/EntrepriseApi";

import { t } from "i18next";
import {
  addNumberToCongeDate,
  addNumberToDate,
  date_En,
  differenceBetweenTwoTime,
  getCompareTodayBetweenTwoDate,
  soustractNumberToDate,
} from "./../Utils/DateUtils";
import moment from "moment";
import CustomSyncLoader from "./Others/CustomSyncLoader";
import AddPointage from "./Pointages/AddPointage";
import CustumMapLeaflet from "./Pointages/CustumMapLeaflet";
import swal from "sweetalert";
import { toast } from "react-toastify";

function ProjetUser() {
  const [currentData, setcurrentData] = useState([]);
  const [allInitialData, setallInitialData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setdata] = useState([]);
  const [size, setsize] = useState(5);
  const [date, setDate] = useState(new Date());
  const [users, setusers] = useState(null);
  const [settings, setsettings] = useState(null);
  const [isCollapsed, setisCollapsed] = useState(false);
  const [conges, setConges] = useState(null);
  const [isShowing, setisShowing] = useState(true);
  /*****************Pointage **********/
  const userId = localStorage.getItem('id')
  const [latitude, setlatitude] = useState(null);
  const [longitude, setlongitude] = useState(null);
  const [device, setdevice] = useState(null);
  const [network, setnetwork] = useState("");

  /**
   * It sets the date to the current date.
   */
  function refreshClock() {
    setDate(new Date());
  }

  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);
  useEffect(() => {
    getData();
  }, []);

  /**
   * It gets the data from the API and sets the data to the state.
   */
  const getData = () => {
    setLoading(true);
    const month = String(new Date().getMonth() + 1).padStart(2, "0");

    getMonthPointageByUserId(userId, month)
      .then((res) => {
        setdata(res.data);
        setcurrentData(res.data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };

  const onChangePage = (pageOfItems) => {
    // update state with new page of items
    setcurrentData(pageOfItems);
  };
  /**
   * It splits the string by the comma and returns the first element.
   * @param word - The word to be checked
   * @returns The time of checkin.
   */
  const getTimeCheckin = (word) => {
    let timeCheckin = word.split(",");
    return timeCheckin[0].split(" ")[1];
  };
  /**
   * It takes a string and splits it into an array. Then it takes the last element of the array and
   * splits it into another array. Then it takes the second element of that array and returns it.
   * @param word - The word to be checked.
   * @returns The last word of the string, split by a comma.
   */
  const getTimeCheckout = (word) => {
    let timeCheckout = word.split(",");
    if (timeCheckout.length === 1) {
      return "-";
    } else {
      return timeCheckout[timeCheckout.length - 1].split(" ")[1];
    }
  };





  /**
   * *This function is used to toggle the collapse state of the sidebar.*
   */
  const handleCollapse = () => {
    setisCollapsed(!isCollapsed);
  };

  /***dave pointage  */


  const getUA = () => {
    let device = "Unknown";
    const ua = {
      "Generic Linux": /Linux/i,
      Android: /Android/i,
      BlackBerry: /BlackBerry/i,
      Bluebird: /EF500/i,
      "Chrome OS": /CrOS/i,
      Datalogic: /DL-AXIS/i,
      Honeywell: /CT50/i,
      iPad: /iPad/i,
      iPhone: /iPhone/i,
      iPod: /iPod/i,
      macOS: /Macintosh/i,
      Windows: /IEMobile|Windows/i,
      Zebra: /TC70|TC55/i,
    };
    Object.keys(ua).map((v) => navigator.userAgent.match(ua[v]) && (device = v));
    return device;
  };


  useEffect(() => {
    //setdevice(getUA());
    setdevice(getUA() + "/" + getBrowser());

    const location = window.navigator && window.navigator.geolocation;

    if (location) {
      location.getCurrentPosition(
        (position) => {
          setlatitude(position.coords.latitude);
          setlongitude(position.coords.longitude);
        },
        (error) => {
          setlatitude(-1);
          setlongitude(-1);
        }
      );
    }
  }, []);


  const getBrowser = () => {
    const userAgent = navigator.userAgent;
    let browser = "unkown";
    // Detect browser name
    browser = /ucbrowser/i.test(userAgent) ? "UCBrowser" : browser;
    browser = /edg/i.test(userAgent) ? "Edge" : browser;
    browser = /googlebot/i.test(userAgent) ? "GoogleBot" : browser;
    browser = /chromium/i.test(userAgent) ? "Chromium" : browser;
    browser = /firefox|fxios/i.test(userAgent) && !/seamonkey/i.test(userAgent) ? "Firefox" : browser;
    browser = /; msie|trident/i.test(userAgent) && !/ucbrowser/i.test(userAgent) ? "IE" : browser;
    browser =
      /chrome|crios/i.test(userAgent) && !/opr|opera|chromium|edg|ucbrowser|googlebot/i.test(userAgent)
        ? "Chrome"
        : browser;
    browser =
      /safari/i.test(userAgent) && !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(userAgent)
        ? "Safari"
        : browser;
    browser = /opr|opera/i.test(userAgent) ? "Opera" : browser;

    // detect browser version
    switch (browser) {
      case "UCBrowser":
        return `${browser}/${browserVersion(userAgent, /(ucbrowser)\/([\d\.]+)/i)}`;
      case "Edge":
        return `${browser}/${browserVersion(userAgent, /(edge|edga|edgios|edg)\/([\d\.]+)/i)}`;
      case "GoogleBot":
        return `${browser}/${browserVersion(userAgent, /(googlebot)\/([\d\.]+)/i)}`;
      case "Chromium":
        return `${browser}/${browserVersion(userAgent, /(chromium)\/([\d\.]+)/i)}`;
      case "Firefox":
        return `${browser}/${browserVersion(userAgent, /(firefox|fxios)\/([\d\.]+)/i)}`;
      case "Chrome":
        return `${browser}/${browserVersion(userAgent, /(chrome|crios)\/([\d\.]+)/i)}`;
      case "Safari":
        return `${browser}/${browserVersion(userAgent, /(safari)\/([\d\.]+)/i)}`;
      case "Opera":
        return `${browser}/${browserVersion(userAgent, /(opera|opr)\/([\d\.]+)/i)}`;
      case "IE":
        const version = browserVersion(userAgent, /(trident)\/([\d\.]+)/i);
        // IE version is mapped using trident version
        // IE/8.0 = Trident/4.0, IE/9.0 = Trident/5.0
        return version ? `${browser}/${parseFloat(version) + 4.0}` : `${browser}/7.0`;
      default:
        return `unknown/0.0.0.0`;
    }
  };
  const browserVersion = (userAgent, regex) => {
    return userAgent.match(regex) ? userAgent.match(regex)[2] : null;
  };

  const handelSave = () => {
    const now = new Date();

    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
    const datePointage = local.toISOString().slice(0, 16);
    addPointageByUserId(userId, datePointage, latitude, longitude, device, network, datePointage).then((res) => {
      if (res.status === 200) {
        toast.success(t("Votre pointage a été enregistré avec succès !"));
        getData()
      } else {
        throw error()
      }
    }).catch(() => {
      toast.error(t("Une erreur est survenue lors de l'enregistrement du pointage."));
    });
  };

  const handelClickPointageSave = () => {
    swal({
      title: t("Confirmation"),
      text: t("Êtes-vous sûr de vouloir effectuer ce pointage ?"),
      icon: "warning",
      buttons: {
        cancel: {
          text: t("Annuler"),
          visible: true,
        },
        confirm: {
          text: t("Oui, pointer"),
          value: true,
        },
      },
      dangerMode: true,
    }).then((confirmpointage) => {
      if (confirmpointage) {
        handelSave();
      }
    });
  };

  const getTypePointage = () => {
    const findPointageAujourdhui = data.find(p => p.pointage_date?.split(',')[0]?.split(" ")[0] === date_En(new Date()))
    if (findPointageAujourdhui) {
      return 'de sortie'

    } else {
      return "d'entre"

    }
  }
  const disabledPointage = () => {
    const findPointageAujourdhui = data.find(p => p.pointage_date?.split(',')[0]?.split(" ")[0] === date_En(new Date()) && p.pointage_date?.split(',')[1]?.split(" ")[0] === date_En(new Date()))
    if (findPointageAujourdhui) {
      return true
    } else {
      return false
    }
  }

  return (
    <>
      <div className="page-header d-xl-flex d-block">
        <div className="page-leftheader">
          <h4 className="page-title">{t("Pointage")}</h4>
        </div>
        <div className="page-rightheader ml-md-auto">
          <div className="d-flex align-items-end flex-wrap my-auto right-content breadcrumb-right">


          </div>
        </div>
      </div>
      {/*End Page header*/}
      {/* Row */}


      <div className="row">
        <div className="col-xl-8 col-md-12 col-lg-12">
          <div className={isCollapsed ? "card  card-fullscreen" : "card"}>
            <div className="card-header  border-0">
              <h4 className="card-title">{t("Pointage du mois")}</h4>
              <div className="card-options">
                <Link to="#" className="card-options-fullscreen mr-2" data-toggle="card-fullscreen" onClick={handleCollapse}>
                  <i className="fe fe-maximize" />
                </Link>
              </div>
            </div>

            <div className="card-body">
              <div className="d-flex mb-6 mt-5">
                <div className="mr-3">
                  <label className="form-label">{t("Note")} : </label>
                </div>
                <div>
                  <span className="badge badge-success-light mr-2">
                    <i className="feather feather-check-circle text-success" /> {t("Pointage d'entrée")}
                  </span>
                  <span className="badge badge-danger-light mr-2">
                    <i className="feather feather-x-circle text-danger" /> {t("Pointage de sortie")}
                  </span>

                </div>
              </div>

              {loading && <CustomSyncLoader></CustomSyncLoader>}
              {!loading && error && <ErrorCustum></ErrorCustum>}
              {!loading && !error && data && (
                <div className="table-responsive">
                  <div id="hr-table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div className="row">


                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <table
                          className="table table-vcenter text-nowrap table-bordered border-bottom dataTable no-footer"
                          id="hr-table"
                          role="grid"
                          aria-describedby="hr-table_info"
                        >
                          <thead>
                            <tr>
                              <th></th>

                              <th>{t("Pointage d'entrée")}</th>
                              <th>{t("Pointage de sortie")}</th>
                              <th>{t("Heures de travail")}</th>

                            </tr>
                          </thead>
                          <tbody>
                            {currentData.map((el) => (
                              <tr key={el.id}>
                                <td>
                                  <div className="d-flex">
                                    <ImageComponent atr={"avatar avatar-md brround mr-3"} picture={el.img}></ImageComponent>
                                    <div className="mr-8 ml-2 mt-0 mt-sm-1 d-block">
                                      <h6 className="mb-1 fs-14">
                                        {el.nom} {el.prenom}
                                      </h6>
                                      <p className="text-muted mb-0 fs-12">{el.email}</p>
                                    </div>
                                  </div>
                                </td>


                                <td>
                                  <span className="badge badge-success">{getTimeCheckin(el.pointage_date)}</span>
                                </td>
                                <td>
                                  <span className="badge badge-danger">{getTimeCheckout(el.pointage_date)}</span>
                                </td>
                                <td>{differenceBetweenTwoTime(getTimeCheckin(el.pointage_date), getTimeCheckout(el.pointage_date))}</td>


                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div className="dataTables_info" id="hr-table_info" role="status" aria-live="polite">
                          {t("Affichage")} {t("de")} 1 {t("à")} {size} {t("sur")} {data.length} {t("entrées")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <Pagination items={data} onChangePage={onChangePage} pageSize={size} />
                      </div>
                    </div>

                  </div>
                </div>
              )}
            </div>
          </div>

        </div>
        {/* leflet */}
        <div className="col-xl-4 col-md-12 col-lg-12">

          <div className="card">
            <div className="card-body">
              <div className="countdowntimer mt-0">
                <span className="border-0" id="clocktimer2" style={{ fontSize: 28 }}>
                  {date.toLocaleTimeString()}
                </span>
                <label className="form-label">{t("Heure actuelle")}</label>
              </div>
              <div className="btn-list text-center mt-5">
                <button className="btn ripple btn-primary" disabled={disabledPointage()} onClick={handelClickPointageSave}>
                  {t("Pointage " + getTypePointage())}
                </button>

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
export default ProjetUser;
